<div class="user-guide-dialog">
  <div class="dialog-header">
    <div class="header-content">
      <mat-icon class="header-icon">help_center</mat-icon>
      <div>
        <h2 mat-dialog-title>User Guide</h2>
        <p class="header-subtitle">Learn how to use the Optwaves Restaurant System</p>
      </div>
    </div>
    <button mat-icon-button class="close-button" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <div class="sidebar">
      <div class="search-box">
        <mat-icon>search</mat-icon>
        <input type="text" placeholder="Search guide..." [(ngModel)]="searchQuery" (input)="filterSections()"
          class="search-input" />
      </div>

      <nav class="sections-nav">
        <button *ngFor="let section of filteredSections" class="section-item"
          [class.active]="selectedSection?.id === section.id" (click)="selectSection(section)">
          <mat-icon>{{ section.icon }}</mat-icon>
          <span>{{ section.title }}</span>
        </button>
      </nav>

      <div class="sidebar-footer">
        <button mat-stroked-button class="full-guide-button" (click)="openFullGuide()">
          <mat-icon>picture_as_pdf</mat-icon>
          <span>Download Full Guide</span>
        </button>
      </div>
    </div>

    <div class="content-area" *ngIf="selectedSection">
      <div class="content-header">
        <mat-icon class="content-icon">{{ selectedSection.icon }}</mat-icon>
        <h3>{{ selectedSection.title }}</h3>
      </div>

      <div class="content-body">
        <div *ngFor="let content of selectedSection.content" class="content-section">
          <!-- Text Content -->
          <p *ngIf="content.type === 'text'" class="text-content">
            {{ content.content }}
          </p>

          <!-- List Content -->
          <div *ngIf="content.type === 'list'" class="list-content">
            <h4 *ngIf="content.title">{{ content.title }}</h4>
            <ul>
              <li *ngFor="let item of content.items">{{ item }}</li>
            </ul>
          </div>

          <!-- Steps Content -->
          <div *ngIf="content.type === 'steps'" class="steps-content">
            <h4 *ngIf="content.title">{{ content.title }}</h4>
            <ol>
              <li *ngFor="let item of content.items">{{ item }}</li>
            </ol>
          </div>

          <!-- Image Content -->
          <div *ngIf="content.type === 'image'" class="image-content">
            <div class="image-placeholder">
              <mat-icon>image</mat-icon>
              <p>{{ content.imageAlt }}</p>
              <span class="image-note">Screenshot placeholder: {{ content.imagePath }}</span>
            </div>
          </div>

          <!-- Warning Content -->
          <div *ngIf="content.type === 'warning'" class="callout callout-warning">
            <mat-icon>warning</mat-icon>
            <div>
              <h5 *ngIf="content.title">{{ content.title }}</h5>
              <p>{{ content.content }}</p>
            </div>
          </div>

          <!-- Tip Content -->
          <div *ngIf="content.type === 'tip'" class="callout callout-tip">
            <mat-icon>lightbulb</mat-icon>
            <div>
              <h5 *ngIf="content.title">{{ content.title }}</h5>
              <p>{{ content.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
